<template>
  <va-modal
    :value="showModal"
    id="requestFormModal"
    ref="requestFormModal"
    size="medium"
    :noOutsideDismiss="true"
    :okText="$t('modals.buttons.save')"
    :cancelText="$t('modals.buttons.cancel')"
    :dangerText="$t('modals.buttons.delete')"
    :showDelete="selectedRequest != null"
    @ok="save"
    @cancel="cancel"
    >

    <div slot="header" class="modal-title pb-3">
      <span>{{ $t('people.appointments_info.new_request') }}</span>
    </div>

    <form class="evollu-form">

      <div class="row">
        <div class="col-12">
          <label class="form-label">{{$t('evocall.inputs.entity')}}</label>
          <multiselect
            v-model="form.entity"
            :options="availableEntitiesOnline"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            :disabled="appointment !== null && appointment !== undefined"
            >
            <template slot="option" slot-scope="{option}">
              <span>{{option.name}}</span>
              <span v-if="option.cities.length">
                ({{option.cities.join(',')}})
              </span>
            </template>
            <template slot="singleLabel" slot-scope="{option}">
              <span>{{option.name}}</span>
              <span v-if="option.cities.length">
                ({{option.cities.join(',')}})
              </span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="form-label">{{$t('people.inputs.person')}}</label>
          <multiselect
            v-model="form.person"
            :options="availablePeople"
            track-by="id"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            :disabled="true"
            >
            <template slot="option" slot-scope="{option}">
              <span>{{ option.name }}</span>
            </template>
            <template slot="singleLabel" slot-scope="{option}">
              <span>{{ option.name }}</span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="form-label">{{$t('evocall.inputs.priority')}}</label>
          <multiselect
            v-model="form.priority"
            :options="availablePriorities"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            :disabled="true"
            >
            <template slot="option" slot-scope="{option}">
              <span>
                <i :class="[option.icon, option.class]" /> &nbsp;
                {{ $t(`evocall.priorities.${option.id}`, option.name) }}
                </span>
            </template>
            <template slot="singleLabel" slot-scope="{option}" class="d-flex align-items-center justify-content-center">
              <span>{{ $t(`evocall.priorities.${option.id}`, option.name) }}</span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="form-label">{{$t('evocall.inputs.type')}}</label>
          <multiselect
            v-model="form.type"
            :options="availableRequestTypes"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            >
            <template slot="option" slot-scope="{option}">
              <span>{{ $t(`evocall.types.${option.id}`, option.name) }}</span>
            </template>
            <template slot="singleLabel" slot-scope="{option}">
              <span>{{ $t(`evocall.types.${option.id}`, option.name) }}</span>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="form.type && form.type.id === 2">
        <div class="col-12">
          <label class="form-label">{{$t('evocall.inputs.activity')}}</label>
          <multiselect
            v-model="form.activity"
            :options="availableActivities"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :disabled="true"
            >
            <template slot="noResult">
              {{$t('multiselect.no_results')}}
            </template>
            <template slot="option" slot-scope="{option}">
              <span>{{ $t(`evocall.activities.${option.id}`, option.name) }}</span>
            </template>
            <template slot="singleLabel" slot-scope="{option}">
              <span>{{ $t(`evocall.activities.${option.id}`, option.name) }}</span>
            </template>
          </multiselect>
        </div>
      </div>

    </form>

  </va-modal>
</template>
<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import { AppointmentService } from '@/api/AuthClinicalService'
import { ActivityService } from '@/api/AuthService'
import { RequestService } from '@/api/EvocallService'
const CallRequestDetailsInfoType = 200
const WriteAccessType = 2

export default {
  components: {
    Multiselect
  },
  props: {
    selectedRequest: {
      type: Object,
      required: false
    },
    appointment: {
      type: Object,
      required: false,
    },
    defaultType: {
      type: Number,
      required: false,
      default: 2
    },
    defaultActivity: {
      type: Number,
      required: false,
      default: 1
    },
    service: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      isLoading: true,
      isRequestingCall: false,
      form: {
        entity: null,
        person: null,
        type: null,
        source: null,
        activity: null,
        priority: null
      },
      availablePeople: [this.appointment.person],
      availablePriorities: [
        { id: 3, name: 'High', icon: 'fa fa-angle-up', class: 'priority priority--high' },
        { id: 2, name: 'Normal', icon: 'fa fa-minus', class: 'priority priority--normal' },
        { id: 1, name: 'Low', icon: 'fa fa-angle-down', class: 'priority priority--low' },
      ],
      availableRequestTypes: [],
      availableRequestSources: []
    }
  },
  created () {
    Promise.all([this.getRequestSources(), this.getRequestTypes(), this.getActivities()])
      .then(() => {
        this.isLoading = false
        this.preFillForm()
      })
      .catch(errors => console.log(errors))
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    getRequestSources: async function () {
      this.availableRequestSources = await RequestService.getSources()
    },
    getRequestTypes: async function () {
      this.availableRequestTypes = await RequestService.getTypes()
    },
    getActivities: async function () {
      this.availableActivities = await ActivityService.query()
    },
    preFillForm: function () {
      if (this.availablePriorities.length > 1) {
        this.form.priority = this.availablePriorities[1]
      }
      if (this.availablePeople.length > 0) {
        this.form.person = this.availablePeople[0]
      }
      if (this.availableRequestTypes.length > 0) {
        let defaultType = this.availableRequestTypes.find(type => type.id === this.defaultType)
        this.form.type = defaultType || this.availableRequestTypes[0]
        if (this.form.type.id === 2 && this.availableActivities.length > 0) {
          let defaultActivity = this.availableActivities.find(activity => activity.id === this.defaultActivity)
          this.form.activity = defaultActivity || this.availableActivities[0]
        }
      }

      if (this.availableRequestSources.length > 0) {
        this.form.source = this.availableRequestSources[0]
      }

      if (this.availableEntitiesOnline.length > 0) {
        this.form.entity = this.availableEntitiesOnline[0]
      }
    },
    save: function () {
      let data = this.getFormData()
      this.createRequest(data)
    },
    cancel: function () {
      this.showModal = false
      setTimeout(() => {
        this.$emit('modal-closed')
      }, 250)
    },
    createRequest: function (data) {
      if (!this.isRequestingCall) {
        this.isRequestingCall = true
        AppointmentService.requestCall(this.service.url, this.appointment.id, data)
          .then(callRequestAppointemnt => {
            this.$emit('appointment-created', { appointment: callRequestAppointemnt })
            this.cancel()
          })
          .catch(errors => {
            console.log(errors)
            if (errors.response && errors.response.status) {
              switch (errors.response.status) {
                case 403:
                  this.showToast(this.$t('clinical.appointments.missing_permissions_for_update'), this.$store.state.errorToastOptions)
                  break
                case 404:
                  this.showToast(this.$t('clinical.appointments.errors.not_found'), this.$store.state.errorToastOptions)
                  break
                default:
                  this.showToast(this.$t('clinical.appointments.something_went_wrong'), this.$store.state.errorToastOptions)
                  break
              }
            }
          })
          .finally(() => {
            this.isRequestingCall = false
          })
      }
    },
    getFormData: function () {
      let data = {}
      if (this.form.type) {
        data.request_type_id = this.form.type.id
        if (this.form.type.id === 2 && this.form.activity) {
          data.activity_id = this.form.activity.id
        }
      }
      if (this.form.priority) {
        data.priority_id = this.form.priority.id
      }
      if (this.form.person) {
        data.person_id = this.form.person.id
      }
      if (this.form.entity) {
        data.entity_id = this.form.entity.id
      }
      return data
    }
  },
  computed: {
    waitingRoomModuleKey: function () {
      return `waiting-room-${this.service.slug}`
    },
    ...mapState({
      evocallService (state) {
        return state.services.find(service => service.url === state.evocall_server) || null
      },
      onlineAudiologistsByEntity (state, getters) {
        return getters[`${this.waitingRoomModuleKey}/onlineAudiologistsByEntity`] || null
      },
    }),
    availableEntitiesOnline: function () {
      let availableEntities = this.evocallService.entities.filter(entity => {
        return this.evocallService.user_permissions.some(p => {
          return (p.entity_id === entity.id || p.entity_id === null) &&
              p.access_type >= WriteAccessType && p.info_type === CallRequestDetailsInfoType
        })
      })
      return availableEntities.filter(entity => {
        return this.onlineAudiologistsByEntity.some(element => {
          return element.entity_id === entity.id && element.onlineAudiologists > 0
        })
      })
    }
  },
  watch: {
    'form.type': {
      handler (newType) {
        if (newType.id === 2) {
          if (this.availableActivities.length) this.form.activity = this.availableActivities[0]
        } else {
          this.form.activity = null
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">

#requestFormModal {
  .evollu-form > .row {
    margin-bottom: 0.75rem !important;
  }
}

</style>
